import { Injectable } from '@angular/core';
import { General } from '@models/general.model';
import { BaseRepository } from '@repos/base.repository';
import { Observable } from 'rxjs';
import {
    ForgetPasswordRequest,
    LoginRequest,
    SendActivationCodeRequest,
    SendActivationCodeResponse,
    SendEmailConfirmCodeRequest,
    SendEmailConfirmCodeResponse,
    VerifyActivationCodeRequest,
    VerifyEmailConfirmCodeRequest
} from '../../models/DTOs/authentication.dto';

@Injectable({providedIn:"root"})
export class AuthRepository extends BaseRepository {

    sendActivationCode(model:SendActivationCodeRequest):Observable<SendActivationCodeResponse>{
        let url =this.baseUrl + 'Account/SendActivationCode';
        return this.post<SendActivationCodeResponse>(url,model)
    }
    verifyActivationCode(model:VerifyActivationCodeRequest):Observable<General>{
        let url =this.baseUrl + 'Account/VerifyActivationCode';
        return this.post<any>(url,model)
    }
    forgetPassword(model:ForgetPasswordRequest){
        let url = this.baseUrl + 'Account/ForgetPassword';
        return this.post<any>(url,model)
    }
    login(model:LoginRequest):Observable<General>{
        let url = this.baseUrl + 'Account/Login';
        return this.post<any>(url,model)
    }
    sendEmailConfirmCode(model:SendEmailConfirmCodeRequest):Observable<SendEmailConfirmCodeResponse>{
        let url = this.baseUrl + 'Account/SendEmailConfirmCode';
        return this.post<any>(url,model)
    }
    verifyEmailConfirmCode(model:VerifyEmailConfirmCodeRequest){
        let url = this.baseUrl + 'Account/SendEmailConfirmCode';
        return this.post<any>(url,model)
    }
    logoutUser(accessToken?: string){
        let url = this.baseUrl + 'v1/Account/Logout';
        // Logout is subscribed after local auth state is cleared; retain this request's token.
        const options = accessToken
            ? { ...this.options_, headers: this.options_.headers.set('Authorization', `Bearer ${accessToken}`) }
            : this.options_;
        return this.getWithoutCache<any>(url, options);
    }
    loginAsUser(guid:string){
        let url = this.baseUrl + 'Account/loginasuser/' + guid;
        return this.post(url,{})
    }


}
